import amazon_connect from "./../../assets/images/amazon_connect.png";
import fujitsu_uvance from "./../../assets/images/fujitsu_uvance.png"; 
import mail_icon from "./../../assets/images/mail.png"; 
import chat_icon from "./../../assets/images/chat.png"; 
import heasset_icon from "./../../assets/images/headset.png"; 
import connection_icon from "./../../assets/images/connection.png"; 
import fujitsu_logo from "./../../assets/images/fujitsu_logo.png"; 
import { AwsRum, AwsRumConfig } from 'aws-rum-web';

try {
  const config: AwsRumConfig = {
    sessionSampleRate: 1,
    guestRoleArn: "arn:aws:iam::501559682660:role/RUM-Monitor-eu-central-1-501559682660-5428325208661-Unauth",
    identityPoolId: "eu-central-1:ab702b79-3b04-4afa-9903-a2b84a22f37e",
    endpoint: "https://dataplane.rum.eu-central-1.amazonaws.com",
    telemetries: ["performance","errors","http"],
    allowCookies: true,
    enableXRay: true
  };

  const APPLICATION_ID: string = 'd3124458-c876-48b1-88cf-131d9e08aefc';
  const APPLICATION_VERSION: string = '1.0.0';
  const APPLICATION_REGION: string = 'eu-central-1';

  const awsRum: AwsRum = new AwsRum(
    APPLICATION_ID,
    APPLICATION_VERSION,
    APPLICATION_REGION,
    config
  );
} catch (error) {
  // Ignore errors thrown during CloudWatch RUM web client initialization
}

const Login = () => {
    Notification.requestPermission().then((permission) => {
        // If the user accepts, let's create a notification
        if (permission === "granted") {
        //   const notification = new Notification("Hi there!");
        }else if (permission === "denied"){
            // alert("Please make sure you grant permission for notifications")
            console.log("Please make sure you grant permission for notifications")
        }
      });
    let logInURL = process.env.REACT_APP_AWS_CCP_LOGIN_URL;
    return (
        <div className="login-wapper">
                
            <div className="login-logo flex-grow-1">
                <div className="signin-box text-center">
                    <img className='cloud_icon' src={amazon_connect} alt="cloud icon" />
                    <h5 className="text-dark mb-3">Welcome</h5>
                    <button className="btn btn-lg btn-primary signin-btn shadow" onClick={() => {window.open(logInURL, '_blank');}}>Log in</button>
                    <div className="login-icons">
                        <ul className="login-list-icon d-flex list-unstyled">
                            <li><img className='' src={mail_icon} alt="icon" /></li>
                            <li><img className='' src={chat_icon} alt="icon" /></li>
                            <li><img className='' src={heasset_icon} alt="icon" /></li>
                            <li><img className='' src={connection_icon} alt="icon" /></li>
                        </ul>
                    </div>
                </div>

                <div className="login-footer">
                <p>Fujitsu Restricted &copy; Fujitsu 2022</p>
                </div>
            </div>
            <div className="login-right-bg">
                <div className="d-flex justify-content-end">
                    <img className='fujitsu_logo' src={fujitsu_logo} alt="fujitsu logo" />
                </div>
                <img className='fujitsu_uvance' src={fujitsu_uvance} alt="fujitsu uvance" />
            </div>
            
        </div>
    )
}
export default Login;